<template>
  <div class="my-item3 z-info">
    <template v-if="list && list.items.length">
      <div style="min-height: 400px;margin-bottom:20px;">
        <Row :gutter="30">
          <Col :sm="12" :md="6" v-for="(item, index) in list.items" :key="'ProductInt-' + index" class="w-20">
          <div class="pro">
            <div class="pro-top">
              <div class="pro-top-brand" v-if="typeList[item.topicType] &&  item.topicType !== 0">
                {{typeList[item.topicType]}}
              </div>
              <div v-if="!item.isShow" class="product-show">
                <i class="icon iconfont icon-hide"></i>
              </div>
              <img :src="item.banner[0]" v-if="item.banner && item.banner[0]" />
              <img src="@/assets/img/empty.png" v-else />
            </div>
            <div class="pro-title">
              <p class="info" :title="item.name" :class="setProStatus(item.applyStart, item.applyEnd)">{{item.name}}</p>
              <div class="time" v-if="item.isApply && false">
                剩余：
                {{item.applyEnd | time_sort}}
              </div>
            </div>

            <div class="pro-tool">
              <!-- <div class="pro-tool-item z-del">
                  <Poptip confirm placement="top-start" title="确认删除此展品吗 ?" @on-ok="delItem(item)">删除</Poptip>
                </div>-->
              <div class="pro-tool-item" @click="showEdit(item)">编辑</div>
              <div class="pro-tool-line">|</div>
              <div class="pro-tool-item" @click="setTopic(item)">推荐</div>
              <div class="pro-tool-line">|</div>
              <div class="pro-tool-item">
                <Dropdown trigger="custom" :visible="item.visible">
                  <a href="javascript:void(0)" style="color:#808080;" @click="toggleOpen(index)">
                    更多
                    <Icon type="ios-arrow-down"></Icon>
                  </a>
                  <DropdownMenu slot="list" style="text-align:center;">
                    <DropdownItem v-if="item.isShow" @click.native="showOff(item)">屏蔽</DropdownItem>
                    <DropdownItem v-else @click.native="showOn(item)">显示</DropdownItem>
                    <DropdownItem>
                      <Poptip confirm placement="top-start" title="确认删除此展品吗 ?" @on-ok="delItem(item, index)" @on-cancel="handleClose(index)">
                        <div style="width: 100px;">删除</div>
                      </Poptip>
                    </DropdownItem>
                    <DropdownItem v-if="item.isApply" @click.native="listDown(item)">名单下载</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize" style="text-align: center;padding: 20px 0;">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
    </template>
    <div v-else style="line-height:500px;background-color:#fff;text-align:center;">暂无数据！</div>

    <!-- 修改展商置顶 -->
    <exTopic :show="editTopic" v-if="editTopic" @finish="init()" :editTopicnfo="editTopicnfo" @close="editTopic=false;editTopicnfo=null;" />

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import emptyList from "@components/emptyList/emptyList";
import exTopic from "../components/ex-topic.vue";

export default {
  name: "host-product-item",
  props: {
    searchField: {
      type: String,
      default () {
        return "1";
      }
    }
  },
  data () {
    return {
      editTopic: false,
      editTopicnfo: null,

      visible: false,
      deleted: false,
      edit: false,
      list: null,
      editInfo: null,

      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,

      typeList: [
        "不推荐",
        "热门",
        "推荐",
      ],
    };
  },
  computed: {
    ...mapGetters({
      hostExhibition: "hostSetModule/getHostExhibition"
    }),
    option () {
      return {
        ExhibitionId: this.hostExhibition.id,
        // AgentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
        PageSize: this.pageSize,
        PageIndex: this.pageIndex,
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "Name",
                  Value: `%${this.searchField}%`
                }
              }
            ]
          }
        }
      };
    }
  },
  components: {
    emptyList,
    exTopic
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getHostProductByExId: "productModule/getHostProductByExId",
      getProduct: "productModule/getProduct",
      delProduct: "productModule/delProduct",
      setProductShow: "productModule/setProductShow",
      getProductApply: "productFeedbackModule/getProductApply"
    }),
    setTopic (item) {
      // 设置置顶
      this.editTopicnfo = item;
      this.editTopic = true;
    },
    reload() {
      this.pageIndex = 1;
      this.init();
    },
    async init () {
      let proData = await this.getHostProductByExId(this.option);
      if (proData) {
        proData.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          } else {
            c.banner = [];
          }
          c.visible = false;
        });
        this.list = proData;
        this.pageSize = proData.pageSize;
        this.pageIndex = proData.pageIndex;
        this.totalCount = proData.totalCount;
      }
    },
    // 修改展品显示、屏蔽
    async showOff (item) {
      let result = await this.setProductShow({ Id: item.id, IsShow: false });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async showOn (item) {
      let result = await this.setProductShow({ Id: item.id, IsShow: true });
      if (result.successed) {
        this.$Message.success("修改成功");
        this.init();
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    async listDown (item) {
      let applyList = await this.getProductApply({ By: item.id });
      let applyList2 = await this.getProductApply({
        By: item.id,
        PageSize: applyList.totalCount
      });
      const exData = this.transformData(applyList2.items);
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
        const tHeader = [
          "姓名",
          "职务",
          "公司",
          "手机号码",
          "国家",
          "省份",
          "城市",
          "县",
          "地址"
        ]; //这个是表头名称 可以是iveiw表格中表头属性的title的数组
        const filterVal = [
          "name",
          "jobTitle",
          "company",
          "mob",
          "country",
          "province",
          "city",
          "county",
          "address"
        ]; //与表格数据配合 可以是iview表格中的key的数组
        const data = this.formatJson(filterVal, exData);
        export_json_to_excel(tHeader, data, "展品试用名单"); //列表excel  这个是导出表单的名称
      });
    },
    transformData (data) {
      // 转换数据
      let arr = [];
      data.forEach(c => {
        arr.push({
          name: c.name,
          jobTitle: c.jobTitle,
          company: c.company,
          mob: c.mob,
          country: c.country,
          province: c.province,
          city: c.city,
          county: c.county,
          address: c.address
        });
      });
      return arr;
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    del (item) {
      this.$Modal.confirm({
        content: `确认删除 ${item.name} 此展品吗 `,
        onOk: () => {
          this.delItem(item);
        },
        onCancel: () => {
          this.deleted = false;
        }
      });
    },
    async delItem (item, index) {
      let result = await this.delProduct(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
      this.handleOpen(index);
    },
    showEdit (item) {
      this.$router.push(
        `/host/index/pro/pro-edit?id=${item.id}&compId=${item.compId}`
      );
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
    setProStatus (start, end) {
      let status = {
        end: false,
        ing: false,
        start: false
      };
      if (!start || !end) return status;
      let startNum = new Date(start).getTime();
      let endNum = new Date(end).getTime();
      let now = new Date().getTime();
      if (endNum < now) status.end = true;
      if (endNum > now && startNum < now) status.ing = true;
      if (startNum > now) status.start = true;
      return status;
    },

    handleOpen (index) {
      this.list.items[index].visible = true;
    },
    handleClose (index) {
      this.list.items[index].visible = false;
    },
    toggleOpen (index) {
      let visible = this.list.items[index].visible;
      this.list.items[index].visible = !visible;
    }
  }
};
</script>

<style lang="scss">
.my-item3 {
  min-width: 600px;
  padding: 30px 30px 50px 30px;

  &-box {
    background-color: #fff;
    margin-bottom: 30px;
  }

  .pro {
    margin-bottom: 20px;
    position: relative;
    &-top {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;
      background-color: #f8f9fb;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        z-index: 1;
      }
      &-brand {
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        padding: 3px 5px;
        color: #fff;
        background: #1890ff;
      }
    }

    &-title {
      background: #fff;
      // height: 33px;
      padding: 10px 10px 7px 12px;
      .info,
      .time {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #1a1a1a;
        text-align: center;
        &.end {
          color: #f00;
        }
        &.ing {
          color: green;
        }
        &.start {
          color: #fe791e;
        }
      }
      .time {
        color: #fe791e;
      }
    }

    &-tool {
      display: flex;
      align-items: center;
      justify-content: space-around;
      background-color: #f8f9fb;

      &-item {
        flex: 1;
        line-height: 48px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;

        &.z-del {
          color: #f00;
        }

        &.z-primary {
          color: #1890ff;
        }
      }

      &-line {
        color: #e8e8e8;
        font-size: 20px;
      }
    }
  }

  .my-page {
    padding-bottom: 50px;
  }
  .product-show {
    position: absolute;
    z-index: 100;
    right: 0;
    width: 0;
    height: 0;
    border-width: 20px;
    border-style: solid;
    border-color: #ccc #ccc transparent transparent;
    i {
      position: absolute;
      top: -25px;
      right: -20px;
      color: #fff;
      font-size: 25px;
    }
  }
}
</style> 
